import React from 'react';
import './App.css';
import Mobile from './component/mobile';
import Laptop from './componentLaptop/laptop';
import { useMediaQuery } from 'react-responsive';



function App() {
  const isMobileDevice = useMediaQuery({
    query: "(max-device-width: 414px)",
  });  
  const isBigScreen = useMediaQuery({
    query: "(min-device-width: 415px )",
  });
  return (
    <div className="App">
    {isMobileDevice && <Mobile />}
    {isBigScreen && <Laptop />}
  </div>
  );
}

export default App;